var env = (process.env.REACT_APP_ENV || 'development');
var config = require('./configs/' + env + '.js');
config.env = env;
module.exports = config;

